import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '../../App';
import Odd from '../../common/Odd';
import { useAbsolutePath } from '../../data/seo/seoRouteUtils';
import { isSeoSettingsNoFollow } from '../../data/seo/seoUtils';
import { getBetDescription } from '../../data/utils/getBetDescription';
import { getNumberOfColsMobile } from '../../data/utils/getNumberOfColsMobile';
import { PrematchContext } from '../Prematch';
import { TournamentContext } from './TournamentDataFetcher';

function TournamentMatch(props) {
    const appContext = React.useContext(AppContext);
    const prematchContext = useContext(PrematchContext);
    const tournamentContext = useContext(TournamentContext)
    const match = props.match;
    const bets = match.bets;
    let betsList = bets;

    if (!props.expanded) {
        const selected = props.bet;
        if (selected) {
            // If the main line is set show the corresponding bet
            if (selected.handicap != null && selected.mainLine !== 0) {
                const bet = bets.find(bet => bet.id === selected.id && bet.handicap == selected.mainLine);
                if (bet != null) {
                    betsList = [bet];
                }
            } else {
                betsList = [bets.find(bet => bet.id === selected.id && bet.handicap == selected.handicap)];
                if (betsList[0] === undefined) {
                    betsList = [bets.find(bet => bet.id === selected.id)];
                }
            }
        } else {
            betsList = [bets[0]];
        }

        // If the bet has an handicap type = 6, show all the other bets with the same type too
        const firstBet = betsList[0];
        if (betsList[0].tipoHandicap === 6) {
            bets.forEach(bet => {
                if (bet.tipoHandicap === 6 && bet.id === firstBet.id && bet.handicap != firstBet.handicap) {
                    betsList.push(bet);
                }
            });
        }
    }

    /*function handleClick() {
        prematchContext.openMatch(match);
    }*/

    function handleClickHref(e){
        //e.preventDefault();
        if (window.blockHistoryChanges()) {
            e.preventDefault();
            prematchContext.openMatchFromTournament({
                ...tournamentContext.data,
                liveMatches: tournamentContext.liveMatches
            }, match);
        }else{
            appContext.setHandleOpenFromPath(true);
            prematchContext.openMatchFromTournament({
                ...tournamentContext.data,
                liveMatches: tournamentContext.liveMatches
            }, match);
        }

        
    }

    //const absoluteMatchPath = useAbsolutePath(match.urlPath,null,match.urlPathSeo,false);
    const relativeMatchPath = useAbsolutePath(match.urlPath,null,match.urlPathSeo,true);
    const noFollow = isSeoSettingsNoFollow(match.urlPathSeoSettings);


    // If the compact view is enabled the main bet group must always be shown, even if odds are all locked.
    // If the expanded view is enabled, we only show the bets whose odds aren't all null/locked.
    if (tournamentContext.expanded) {
        betsList = betsList.filter(bet => {
            let hasOdds = false;
            for (let i = 0; i < bet.odds.length; i++) {
                if (bet.odds[i].value != null) {
                    hasOdds = true;
                }
            }
            return hasOdds;
        });
    }
    // betsList = filtraParametriche(betsList);

    return (
        <>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <Link to={encodeURI(relativeMatchPath) } className="info-avvenimento" onClick={handleClickHref.bind(this)} {...(noFollow ? {rel: 'nofollow'}:{})} >
                <div className="nome-avvenimento">
                    <span className="text-small">{match.team1}</span>
                    <span className="text-small">{match.team2}</span>
                </div>
                <span className="ora-avvenimento text-small push-right">{match.time}</span>
                <span className="ora-avvenimento text-small">(+{match.plus})</span>
                <div className="arrow-container arrow-container-small">
                    <span className="arrow arrow-right"></span>
                </div>
            </Link>
            {betsList.map((bet, i) => {
                {/* if (bet.parametrica) {
                    return (
                        <React.Fragment key={bet.id}>
                            <div className="label-desc-scom-vista-estesa">{bet.desc}</div>
                            <HandicapSelectorBet bets={match.betsById.get(bet.id)} />
                        </React.Fragment>
                    );
                } */}
                return (
                    <React.Fragment key={i}>
                        {props.expanded &&
                            <div className="label-desc-scom-vista-estesa">{getBetDescription(bet, true)}</div>
                        }
                        <div className={"esiti-container grid-columns-" + getNumberOfColsMobile(bet.odds.length)}>
                            {bet.odds.map((odd, i) => {
                                return <Odd key={i} {...odd} />;
                            })}
                        </div>
                    </React.Fragment>
                )
            })}
        </>
    );
}

export default TournamentMatch;